var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMessageDefault = function SvgMessageDefault(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18181B",
    fillRule: "evenodd",
    d: "M13.5 1.667c.687 0 1.252-.001 1.71.036.469.038.9.12 1.304.326l.23.129c.522.32.947.78 1.227 1.328l.071.153c.155.36.221.741.255 1.15.037.46.037 1.024.037 1.71v3.668c0 .686 0 1.25-.037 1.71-.034.41-.1.79-.255 1.15l-.071.153a3.334 3.334 0 0 1-1.227 1.328l-.23.129c-.404.206-.835.288-1.304.326-.458.038-1.023.037-1.71.037h-2.373l-3.94 3.15a.834.834 0 0 1-1.353-.65v-2.503a14.496 14.496 0 0 1-1.044-.034c-.41-.033-.79-.1-1.15-.254l-.153-.072a3.334 3.334 0 0 1-1.328-1.227l-.129-.23c-.206-.404-.288-.835-.326-1.303-.038-.46-.037-1.024-.037-1.71V6.5c0-.687 0-1.251.037-1.71.038-.468.12-.9.326-1.304l.129-.23c.32-.521.779-.947 1.328-1.227l.153-.071c.36-.154.74-.221 1.15-.255.459-.037 1.024-.036 1.71-.036h7Zm-7.666 7.5a.833.833 0 1 0 0 1.666h5.833a.833.833 0 0 0 0-1.666H5.834Zm0-3.334a.833.833 0 0 0 0 1.667h8.333a.833.833 0 0 0 0-1.667H5.834Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMessageDefault);
export default ForwardRef;